<script setup>
import { inject, ref } from 'vue'
import { apolloClient } from 'boot/apollo'
import referencesQuery from 'src/graphql/referencesQuery.gql'
import { useRouter } from 'vue-router'
import ReferencesSwiper from 'components/reference/ReferencesSwiper.vue'
import AppButton from '#/general/AppButton.vue'

const router = useRouter()
const references = ref(null)
const swiper = ref(0)
const { screen } = inject('Shared')

await loadReferences()

async function loadReferences () {
  try {
    const referencesData = await apolloClient.query({
      query: referencesQuery,
      variables: {
        referencesInput: {
          rowsPerPage: 10
        }
      }
    })
    references.value = JSON.parse(JSON.stringify(referencesData?.data?.references))
  } catch (e) {
    console.log(JSON.parse(JSON.stringify(e)))
  }
}
</script>

<template lang="pug">
.referencesContainer(v-if="references && references.length > 0")
  .routerPageSize
    .references--title Entwicklungsprojekte aus der Hand der Raumpioniere
    .references
      references-swiper(:items="references")
      .references-btn-container
        app-button.references-btn(
          label="Weitere Referenzen"
          to="/referenzen"
          padding="0 44px"
        )
</template>

<style lang="sass">
.referencesContainer
  display: flex
  justify-content: center
  width: 100%
  padding: 0 15px
  flex-direction: column
  align-items: center
  .swiper-wrapper
    padding-bottom: 5px !important
  .references--title
    font-weight: 500
    line-height: 130%
    text-align: center
    color: #22223C
    @media screen and (min-width: 600px)
      margin: 163px 0 100px
      font-size: 34px
    @media screen and (max-width: 600px)
      margin: 72px 0 27px
      font-size: 24px
  .references
    @media screen and (min-width: 1024px)
      margin-bottom: 175px
    @media screen and (max-width: 1024px)
      margin-bottom: 8px
  .references-btn-container
    width: 100%
    display: flex
    justify-content: center
    align-items: center
    margin-top: 57px
</style>
